// environment.staging.ts

import { environmentShared } from './environment.shared';

const env: Partial<typeof environmentShared> = {
  production: true,
  moduleFederationUrl: {
    shell: '/shell',
    dashboard: '/dashboardremote',
    reports: '/reportsremote',
    visibility: '/visibilityremote',
    alerts: '/alertsremote',
    collaboration: '/collaborationremote',
    bat: '/batremote',
    admin: '/adminremote',
    common: '/commonremote',
    ewqf:'/ewqfremote',
    dataquality:'/dataqualityremote',
    eventmanagement:'/eventmanagementremote'

  },
  localJson: false,
  apiUrl: 'https://vna-sit.apllogistics.com',
  feedbackDates: [1, 3, 4],
  // token: '004i4Ze9XkvF4S-lLrlvAldRsi2WN6Up_dLwLVb-Bv',
  clientId: '0oaf9a093qxPcrkTt1d7',
  appInsights: {
    instrumentationKey: '508226c1-19e7-498b-920e-6c8df52bc654',
  },
};

// Export all settings of common replaced by dev options
export const environment = Object.assign(environmentShared, env);
